import { Controller } from "@hotwired/stimulus"
import { NavigationHelper } from "~/helpers/navigation_helper"
import { Chart, registerables } from "chart.js"

Chart.register(...registerables)

export default class extends Controller {
  static targets = ["sentChart", "openChart", "clickChart", "replyChart", "successfulChart"]

  connect() {
    // in case the user is on a Turbo preview of the page,
    // don't fetch the preview
    if (NavigationHelper.pageIsPreview()) {
      return
    }

    this.load()
  }

  load() {
    var config, donutEl, donutPie, el
    var charts = [
      this.sentChartTarget,
      this.replyChartTarget,
      this.openChartTarget,
      this.clickChartTarget,
      this.successfulChartTarget,
    ]

    // Override doughnut legends
    Chart.overrides["doughnut"].plugins.legend.display = false

    charts.forEach(function (el) {
      config = {
        type: "doughnut",
        data: {
          datasets: [
            {
              data: [el.dataset.value, el.dataset.total - el.dataset.value],
              backgroundColor: [el.dataset.color, "#f5f5f5"],
              borderWidth: [0, 0],
            },
          ],
          labels: ["Sent", ""],
        },
        options: {
          events: null,
          responsive: true,
          cutout: "80%",
          layout: {
            padding: 20,
          },
          animation: {
            duration: 0,
          },
          plugins: {
            legend: {
              display: false,
            },
            tooltip: {
              enabled: false,
            },
          },
        },
      }

      donutEl = el.getContext("2d")
      donutPie = new Chart(donutEl, config)
    })
  }
}
